import LogoMark from "@/components/LogoMark";

export default function Footer() {
  return (
    <footer className="border-t border-gold/10 py-10" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-5 md:flex-row md:px-10">
        <div className="flex items-center gap-3">
          <LogoMark className="h-6 w-6" />
          <span className="leading-none">
            <span className="block font-serif text-xl text-cream">
              APSARA<span className="text-gold">.</span>
            </span>
            <span className="mt-1 block text-[0.5rem] font-light uppercase tracking-[0.4em] text-gold/90">
              Kollektion
            </span>
          </span>
        </div>
        <p className="text-xs font-light uppercase tracking-[0.25em] text-cream/50">
          © {new Date().getFullYear()} APSARA Kollektion — Punjabi Schmuck &amp; Suits
        </p>
        <p className="text-xs font-light uppercase tracking-[0.25em] text-cream/50">
          Gemacht mit Pyaar <span className="font-gurmukhi normal-case">ਪਿਆਰ</span>
        </p>
        <div className="flex items-center gap-5">
          <a
            href="/impressum"
            data-testid="footer-impressum"
            className="text-xs font-light uppercase tracking-[0.25em] text-cream/30 transition-colors duration-300 hover:text-gold"
          >
            Impressum
          </a>
          <a
            href="/datenschutz"
            data-testid="footer-datenschutz"
            className="text-xs font-light uppercase tracking-[0.25em] text-cream/30 transition-colors duration-300 hover:text-gold"
          >
            Datenschutz
          </a>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="text-xs font-light uppercase tracking-[0.25em] text-cream/30 transition-colors duration-300 hover:text-gold"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
